module.exports = __webpack_public_path__ + "img/icon_6.83ba2faf.svg";